import React from "react";
import PropTypes from "prop-types";
import { Flyout } from "../Flyout/Flyout";
import { ColorSelectorFlyout } from "./ColorSelectorFlyout/ColorSelectorFlyout";

import "./ColorSelector.scss";

export class ColorSelector extends React.Component {
  static propTypes = {
    onChange: PropTypes.func,

    color: PropTypes.object,
  };

  constructor(props) {
    super(props);

    this.state = {
      colorValue: props.color,
      colorSelectorVisible: false,
    };
    this.flyoutRef = React.createRef();
  }

  handleChange = (color) => {
    const { onChange } = this.props;
    this.setState({ colorValue: color });
    if (onChange) {
      onChange(color);
    }
  };

  handleMouseOverFlyout = (isOpen) => {
    this.setState({ colorSelectorVisible: isOpen });
  };

  render() {
    const { colorSelectorVisible, colorValue } = this.state;

    return (
      <div className="ColorSelector" data-testid="ColorSelector">
        <div
          className="RGB__Value"
          data-testid="RGB__Value"
          onFocus={() => this.setState({ colorSelectorVisible: true })}
          onBlur={() => this.setState({ colorSelectorVisible: false })}
          onMouseEnter={() => this.setState({ colorSelectorVisible: true })}
          onMouseLeave={() => this.setState({ colorSelectorVisible: false })}
        >
          <div className="BlockRGBA">
            R: <div>{colorValue.r}</div>
          </div>
          <div className="BlockRGBA">
            G: <div>{colorValue.g}</div>
          </div>
          <div className="BlockRGBA">
            B: <div>{colorValue.b}</div>
          </div>
          <div className="BlockRGBA">
            A: <div>{colorValue.a}</div>
          </div>
          <div
            className="BlockColor"
            style={{
              backgroundColor: `rgba(${colorValue.r}, ${colorValue.g}, ${colorValue.b}, ${colorValue.a})`,
            }}
          />
        </div>
        <div className="SelectorSection">
          {colorSelectorVisible && (
            <Flyout placementRef={this.flyoutRef.current} placement="bottom">
              <ColorSelectorFlyout
                handleMouseOverFlyout={this.handleMouseOverFlyout}
                hexCode={colorValue || "#aaa"}
                color={colorValue}
                onChange={(color) => {
                  this.handleChange(color);
                }}
              />
            </Flyout>
          )}
        </div>
      </div>
    );
  }
}

export default ColorSelector;
